<template>
  <div id="login" v-loading="loading" element-loading-text="登录中...">
    <el-form
      class="container"
      :model="loginForm"
      status-icon
      :rules="rules"
      ref="loginForm"
      v-show="showPage == 'login'"
      label-width="70px"
      :show-close="true"
    >
      <h3 class="title">欢迎来寻最佳买点</h3>
      <el-form-item label="用户名：" prop="username">
        <el-input
          type="username"
          v-model="loginForm.username"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="密码：" prop="password">
        <el-input
          type="password"
          v-model="loginForm.password"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="验证码：" prop="validCode" class="validCode">
        <el-input
          type="text"
          v-model="loginForm.validCode"
          @keyup.enter.native="login('loginForm')"
        ></el-input>
        <div class="identifyCode" @click="refreshCode">
          <SIdentifyLogin id="1" :identifyCode="identifyCode"></SIdentifyLogin>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="login('loginForm')">登录</el-button>
        <el-button @click="resetForm('loginForm')">重置</el-button>
        <el-button @click="exitForm()">离开</el-button>
        <el-link type="primary" :underline="false" @click="goRegister"
          >-> 去注册</el-link
        >
        <el-link type="primary" :underline="false" @click="goResetPassword"
          >-> 重设密码</el-link
        >
      </el-form-item>
    </el-form>
    <el-form
      class="container"
      :model="registerForm"
      status-icon
      :rules="rules"
      ref="registerForm"
      v-show="showPage == 'register'"
      label-width="70px"
    >
      <h3 class="title">欢迎按图索股</h3>
      <el-form-item label="用户名：" prop="username">
        <el-input
          type="username"
          v-model="registerForm.username"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号：" prop="telephone">
        <el-input
          type="telephone"
          v-model="registerForm.telephone"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="密码：" prop="password">
        <el-input
          type="password"
          v-model="registerForm.password"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="确认密码：" prop="rePassword">
        <el-input
          type="password"
          v-model="registerForm.rePassword"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="验证码："
        prop="validCode"
        class="validCode"
        @keyup.enter.native="register('registerForm')"
      >
        <el-input type="text" v-model="registerForm.validCode"></el-input>
        <div class="identifyCode" @click="refreshCode">
          <SIdentifyRegister :identifyCode="identifyCode"></SIdentifyRegister>
        </div>
      </el-form-item>
      <el-form-item align="left">
        <el-button type="primary" @click="register('registerForm')"
          >注册</el-button
        >
        <el-button @click="resetForm('registerForm')">重置</el-button>
        <el-button @click="exitForm()">离开</el-button>
        <el-link type="primary" :underline="false" @click="goLogin"
          >-> 去登录</el-link
        >
        <el-link type="primary" :underline="false" @click="goResetPassword"
          >-> 重设密码</el-link
        >
      </el-form-item>
    </el-form>
    <el-form
      class="container"
      :model="resetPasswordForm"
      status-icon
      :rules="rules"
      ref="resetPasswordForm"
      v-show="showPage == 'resetpassword'"
      label-width="70px"
    >
      <h3 class="title">欢迎按图索股</h3>
      <el-form-item label="用户名：" prop="username">
        <el-input
          type="username"
          v-model="resetPasswordForm.username"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号：" prop="telephone">
        <el-input
          type="telephone"
          v-model="resetPasswordForm.telephone"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="短信验证码：" prop="sms">
        <el-input type="sms" v-model="resetPasswordForm.sms" autocomplete="off">
          <template #suffix>
            <div v-if="countdown > 0" class="second-text">
              {{ countdown }}秒后重新获取
            </div>
            <el-button v-else type="primary" link @click="sendCode"
              >获取验证码</el-button
            >
          </template>
        </el-input>
      </el-form-item>
      <el-form-item label="密码：" prop="password">
        <el-input
          type="password"
          v-model="resetPasswordForm.password"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="确认密码：" prop="rePassword">
        <el-input
          type="password"
          v-model="resetPasswordForm.rePassword"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="验证码："
        prop="validCode"
        class="validCode"
        @keyup.enter.native="resetPassword('resetPasswordForm')"
      >
        <el-input type="text" v-model="resetPasswordForm.validCode"></el-input>
        <div class="identifyCode" @click="refreshCode">
          <SIdentifyRegister :identifyCode="identifyCode"></SIdentifyRegister>
        </div>
      </el-form-item>
      <el-form-item align="left">
        <el-button type="primary" @click="resetPassword('resetPasswordForm')"
          >重设密码</el-button
        >
        <el-button @click="resetForm('resetPasswordForm')">重置</el-button>
        <el-button @click="exitForm()">离开</el-button>
        <el-link type="primary" :underline="false" @click="goRegister"
          >-> 去注册</el-link
        >
        <el-link type="primary" :underline="false" @click="goLogin"
          >-> 去登录</el-link
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import SIdentifyLogin from "@/components/Identify";
import SIdentifyRegister from "@/components/Identify";

export default {
  name: "Login",
  components: {
    SIdentifyLogin,
    SIdentifyRegister
  },
  data() {
    var validateChkcode = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("请输入验证码！"));
      }

      if (value != this.identifyCode) {
        this.refreshCode();
        return callback(new Error("验证码错误！"));
      }
      callback();
    };
    var validateUsername = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入用户名！"));
      } else if (this.showPage == "register") {
        this.$axios
          .post("/api/user/checkname", this.registerForm.username)
          .then(ret => {
            if (ret.data != "SUCCESS") {
              callback(new Error("该用户名已经存在！"));
            }
            callback();
          });
      } else {
        callback();
      }
    };
    var validateTelephone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入11位手机号码！"));
      }
      var pattern = /^1[34578]\d{9}$/;
      if (pattern.test(value)) {
        // 查看手机号是否已被使用
        if (this.showPage == "register") {
          this.$axios
            .post("/api/user/checkphone", this.registerForm.telephone)
            .then(ret => {
              if (ret.data != "SUCCESS") {
                callback(new Error("该手机号已被使用！"));
              }
              callback();
            });
        }
      } else {
        callback(new Error("请输入正确手机号码!！"));
      }
      callback();
    };

    var validateSmsCode = (rule, value, callback) => {
      console.log("validateSmsCode:" + value);
      if (value === "") {
        console.log("validateSmsCode 1");
        callback(new Error("短信验证码不能为空！"));
      }
      var pattern = /\d{6}$/;
      if (!pattern.test(value)) {
        callback(new Error("请输入正确短信验证码!"));
        console.log("validateSmsCode 2s");
      }
      callback();
    };
    var validatePassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码！"));
      }
      callback();
    };
    var validateRePassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码！"));
      } else {
        if (
          this.showPage == "register" &&
          value !== this.registerForm.password
        ) {
          callback(new Error("两次输入密码不一致！"));
        }
        if (
          this.showPage == "resetPasswordForm" &&
          value !== this.resetPasswordForm.password
        ) {
          callback(new Error("两次输入密码不一致！"));
        }
      }

      callback();
    };
    return {
      showPage: "login",
      loading: false,
      countdown: 0,
      codeUrl: "",
      cookiePass: "",
      identifyCodes: "1234567890",
      identifyCode: "",
      loginForm: {
        username: "",
        password: "",
        validCode: "",
        id: ""
      },
      registerForm: {
        username: "",
        telephone: "",
        password: "",
        rePassword: "",
        validCode: "",
        id: ""
      },
      resetPasswordForm: {
        username: "",
        telephone: "",
        sms: "",
        password: "",
        rePassword: "",
        validCode: "",
        id: ""
      },
      rules: {
        username: [{ validator: validateUsername, trigger: "blur" }],
        telephone: [{ validator: validateTelephone, trigger: "blur" }],
        password: [{ validator: validatePassword, trigger: "blur" }],
        validCode: [{ validator: validateChkcode, trigger: "blur" }],
        rePassword: [{ validator: validateRePassword, trigger: "blur" }],
        sms: [{ validator: validateSmsCode, trigger: "blur" }]
      }
    };
  },
  created() {
    this.refreshCode();
  },
  methods: {
    sendCode() {
      var pattern = /^1[34578]\d{9}$/;
      if (
        this.resetPasswordForm.telephone != "" &&
        pattern.test(this.resetPasswordForm.telephone)
      ) {
        this.$axios
          .post("/api/user/sms", this.resetPasswordForm.telephone)
          .then(ret => {
            if (ret.data == "SUCCESS") {
              console.log("请求验证码成功");
            } else {
              this.showMessage("请求验证码失败:" + ret.data);
            }
          });
        this.countdown = 60;
        this.startCountdown();
      }
    },
    /* 倒计时函数 */
    startCountdown() {
      const intervalId = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(intervalId);
        }
      }, 1000);
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
      console.log(this.identifyCode);
    },
    showMessage(message) {
      this.$message.error(message);
    },
    login(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true;
          this.$axios.post("/api/user/login", this.loginForm).then(ret => {
            if (ret.status == 200) {
              if (ret.data.code == 200) {
                // 拿到返回的token和username，并存到store
                let token = ret.data.token;
                let username = ret.data.username;
                let userlevel = ret.data.userlevel;
                this.$store.dispatch("UserLogin", token);
                this.$store.dispatch("UserName", username);
                this.$store.dispatch("UserLevel", userlevel);

                // 跳到目标页
                this.$router.push({ path: this.redirect || "/" });
                // this.$router.go(-1);
                this.loading = false;
              } else {
                // 密码错误
                this.showMessage("密码错误，请重新登陆！");
                this.loading = false;
              }
            } else {
              this.showMessage(ret);
              this.loading = false;
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    register(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .post("/api/user/register", this.registerForm)
            .then(ret => {
              if (ret.data == "SUCCESS") {
                this.$message.success("注册成功，请登录！");
                this.goLogin();
              } else {
                this.showMessage("注册失败，请重新注册！");
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetPassword(formName) {
      console.log(this.resetPasswordForm.sms);
      console.log(formName);
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log("request sent");
          this.$axios
            .post("/api/user/resetpass", this.resetPasswordForm)
            .then(ret => {
              if (ret.data == "SUCCESS") {
                this.$message.success("重置密码成功，请重新登录！");
                this.goLogin();
              } else {
                this.showMessage("重置密码失败:" + ret.data);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    exitForm() {
      this.$router.push({ path: this.redirect || "/" });
    },
    // getValidCode() {
    //   this.codeUrl = this.$global.baseURL + "user/getCheckCode?" + new Date();
    // },
    goRegister() {
      this.showPage = "register";
      this.refreshCode();
    },
    goLogin() {
      this.showPage = "login";
      this.refreshCode();
    },
    goResetPassword() {
      this.showPage = "resetpassword";
      this.refreshCode();
    }
  }
};
</script>
<style>
#login {
  background-position: center;
  height: 100%;
  width: 100%;
  background-size: cover;
  position: fixed;
}

body {
  margin: 0px;
}

.container {
  border-radius: 10px;
  background-clip: padding-box;
  margin: 8% auto;
  width: 420px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}

.title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}

.login-code {
  display: inline-block;
  height: 40px;
}

.validCode .el-input {
  float: left;
  width: 50%;
}
.identifyCode {
  float: right;
}

.el-link {
  margin-left: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue